export default "__VITE_ASSET__CIy$pP7V__"